<template>
  <div
    class="video-box-container"
    :class="{ 'is-current': isCurrent }"
  >
    <video
      ref="videoElement"
      :src="content.url"
      class="video-preview"
      muted
      preload="metadata"
      :poster="content.preview"
      @click="handleClick"
      @loadedmetadata="onVideoLoaded"
    >
      {{ $t('alerts.content-creator.video.unsupported-browser') }}
    </video>
    <div class="video-play-overlay">
      <div class="video-indicator">
        <v-icon
          color="white"
          size="64"
        >
          mdi-play-circle
        </v-icon>
      </div>
    </div>
    <div
      v-if="isLoading"
      class="loading-overlay"
    >
      <v-progress-circular
        indeterminate
        size="48"
        color="primary"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

type Props = {
  content: { url: string; preview: string }
  isCurrent?: boolean
  isLoading?: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  handleClick: []
}>()

const videoElement = ref<HTMLVideoElement | null>(null)

const handleClick = () => {
  emit('handleClick')
}

const onVideoLoaded = () => {
  // Set current time to 1 second to show a preview frame
  if (videoElement.value) {
    videoElement.value.currentTime = 1
  }
}
</script>

<style scoped>
.video-box-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(var(--v-theme-on-background));
  border-radius: 4px;
  overflow: hidden;
}

.video-preview {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
  display: block;
}

.video-play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
}

.video-indicator {
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3;
}

.is-current {
  border: 3px solid rgb(var(--v-theme-primary));
}
</style>
